var version = {
    "name":      "dativery",
    "buildDateCode": "20250113-154726",
    "buildDate": "Mon Jan 13 2025 15:47:26 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20250113-154726",
    "backupUIVersion": "2.2.0-20250109-083351"
}
;
 export default version;